module.exports = __webpack_public_path__ + "img/cancel.0c15f656.svg";